import request from '@/utils/request'
import { parseTime } from '@/utils'
import moment from "moment";

/**
 * 任务大厅分页数据
 * @param {*} query 参数
 */
export function getTaskOrderPager(query) {
  const response = request({
    url: '/Grapher/GetTaskOrderPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        const curTime = moment(moment().format('YYYY-MM-DD'))
        data.list = data.list.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          item.plantStartDateing = item.plantStartDateing ? parseTime(item.plantStartDateing, '{y}.{m}.{d}') : ''
          item.plantEndDateing = item.plantEndDateing ? parseTime(item.plantEndDateing, '{y}.{m}.{d}') : ''

          const dataTime = moment(moment(item.createTime).format('YYYY-MM-DD'))
          const d = curTime.diff(dataTime, 'days');

          if (d == 0)
            item.createTimeTip = `今天`
          else if (d <= 3)
            item.createTimeTip = `${d}天前`
          else
            item.createTimeTip = dataTime.format('MM.DD')

          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 接任务
export function acceptTaskOrder(data) {
  return request({
    url: '/Grapher/AcceptTaskOrder',
    method: 'post',
    data
  })
}

/**
 * 订单详情
 * @param {*} query 参数
 */
export function getTaskOrderDetail(query) {
  const response = request({
    url: '/Grapher/GetTaskOrderDetail',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        if (data.order) {
          data.order.createTime = parseTime(data.order.createTime, '{y}-{m}-{d} {h}:{i}')
          data.order.plantStartDateing = data.order.plantStartDateing ? parseTime(data.order.plantStartDateing, '{y}.{m}.{d}') : ''
          data.order.plantEndDateing = data.order.plantEndDateing ? parseTime(data.order.plantEndDateing, '{y}.{m}.{d}') : ''
        }
        if (data.orderTrace) {
          data.orderTrace.createTime = parseTime(data.orderTrace.createTime, '{y}-{m}-{d} {h}:{i}')
          data.orderTrace.plantStartDate = data.orderTrace.plantStartDate ? parseTime(data.orderTrace.plantStartDate, '{y}.{m}.{d}') : ''
          data.orderTrace.plantEndDate = data.orderTrace.plantEndDate ? parseTime(data.orderTrace.plantEndDate, '{y}.{m}.{d}') : ''
          data.orderTrace.plantDeliveryDate = data.orderTrace.plantDeliveryDate ? parseTime(data.orderTrace.plantDeliveryDate, '{y}.{m}.{d}') : ''
        }
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 取消订单（任务取消）
export function cancelTask(data) {
  return request({
    url: '/Grapher/CancelTaskByGrapher',
    method: 'post',
    data
  })
}

// 订单预约（修改预约拍摄日期）
export function subscribeOrder(data) {
  return request({
    url: '/Grapher/SubscribeOrder',
    method: 'post',
    data
  })
}

/**
 * 分页查询任务订单数据（摄影师订单）
 * @param {*} query 参数
 */
export function getGrapherTaskOrderPager(query) {
  const response = request({
    url: '/Grapher/GetGrapherTaskOrderPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        const curTime = moment(moment().format('YYYY-MM-DD'))
        data.list = data.list.map(item => {
          item.order.createTime = parseTime(item.order.createTime, '{y}-{m}-{d} {h}:{i}')
          item.order.plantStartDateing = item.order.plantStartDateing ? parseTime(item.order.plantStartDateing, '{y}.{m}.{d}') : ''
          item.order.plantEndDateing = item.order.plantEndDateing ? parseTime(item.order.plantEndDateing, '{y}.{m}.{d}') : ''

          const dataTime = moment(moment(item.order.createTime).format('YYYY-MM-DD'))
          const d = curTime.diff(dataTime, 'days');

          if (d == 0)
            item.order.createTimeTip = `今天`
          else if (d <= 3)
            item.order.createTimeTip = `${d}天前`
          else
            item.order.createTimeTip = dataTime.format('MM.DD')

          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 获取摄影师信息
export function getGrapherInfo(query) {
  return request({
    url: '/Grapher/GetGrapherInfo',
    method: 'get',
    params: query
  })
}

// 提现
export function getCash(data) {
  return request({
    url: '/Grapher/GetCash',
    method: 'post',
    data
  })
}

/**
 * 获取客户签字详情
 * @param {*} query 参数
 */
export function getTaskOrderDetailSignature(query) {
  const response = request({
    url: '/Grapher/GetTaskOrderDetail',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

export function sutmitOrderSignature(param) {

  const response = request({
    url: '/Grapher/SubmitOrderSignature',
    method: 'get',
    params: param
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })

}



// WEBPACK FOOTER //
// ./src/api/m/grapher.js